[
  {
    "code": "ZW-BU",
    "name": "Bulawayo"
  },
  {
    "code": "ZW-HA",
    "name": "Harare"
  },
  {
    "code": "ZW-MA",
    "name": "Manicaland"
  },
  {
    "code": "ZW-MC",
    "name": "Mashonaland Central"
  },
  {
    "code": "ZW-ME",
    "name": "Mashonaland East"
  },
  {
    "code": "ZW-MW",
    "name": "Mashonaland West"
  },
  {
    "code": "ZW-MV",
    "name": "Masvingo"
  },
  {
    "code": "ZW-MN",
    "name": "Matabeleland North"
  },
  {
    "code": "ZW-MS",
    "name": "Matabeleland South"
  },
  {
    "code": "ZW-MI",
    "name": "Midlands"
  }
]